<div class="container">
  <img src="../../../../assets/img/trader_logo_aprovado.png" class="logo-size-small" alt="Logo do Itaú Trader" aria-hidden="true">
  <h3 class="title">Desculpe, algo deu errado</h3>
  <ids-icon class="close-icon" size="L">fechar</ids-icon>

  <span class="lighter-font">Ocorreu um erro, ou você não tem permissão para acessar essa aplicação, tente novamente</span>
  <span>Se este erro persistir contate a equipe de câmbio <span *ngIf="codeError || correlationId">e informe o código de erro</span>
    <span *ngIf="codeError"> {{codeError}}</span><span *ngIf="correlationId"> {{correlationId}}</span>
  </span>
</div>
